import React from 'react';
import ReactDOM from 'react-dom';
import { omit } from 'ramda';

const scrollToTop = Component => {
  return class extends React.Component {
    render() {
      return (
        <Component
          {...omit(['scrollTopProp', 'scrollTopPropValue'], this.props)}
        />
      );
    }

    getNode() {
      return ReactDOM.findDOMNode(this);
    }

    doScrollToTop() {
      const node = this.getNode();

      if (node) {
        node.scrollTop = 0;
      }
    }

    componentDidUpdate(prevProps) {
      const scrollTopProp = this.props.scrollTopProp;
      const scrollTopPropValue = this.props.scrollTopPropValue;

      const value = this.props[scrollTopProp];
      const prevValue = prevProps[scrollTopProp];

      if (value !== prevValue && value === scrollTopPropValue) {
        this.doScrollToTop();
      }
    }
  };
};

export default scrollToTop;
